import shortid from 'shortid';

export function applyIdsToObject(obj: any): any {
    if(!obj) {
        return;
    }

    if(!obj.id) {
        obj.id = shortid.generate();
    }

    for(let key in obj) {
        if(obj.hasOwnProperty(key)) {
            if(obj[key] instanceof Array) {
                obj[key].forEach((x: any) => {
                    if(typeof x === "object") {
                        applyIdsToObject(x);
                    }
                });
            } else if(typeof obj[key] === "object") {
                applyIdsToObject(obj[key]);
            }
        }
    }
    return obj;
}

export function camelCaseProperties(o: Object): Object {
    var newO: any, origKey: string, newKey: string, value:any
    if (o instanceof Array) {
        return o.map(function(value) {
            if (typeof value === "object") {
                value = camelCaseProperties(value)
            }
            return value;
        })
    } else {
        newO = {}
        for (origKey in o) {
            if (o.hasOwnProperty(origKey)) {
                newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
                value = o[origKey];
                if (value instanceof Array || (value !== null && value.constructor === Object)) {
                value = camelCaseProperties(value)
                }
                newO[newKey] = value
            }
        }
    }
    return newO
}

export function getClosestParent(el: HTMLElement | null, selector: string, stopSelector: HTMLElement | string): HTMLElement | null {
    let retval: HTMLElement | null = null,
        stopSelectorString = getSelector(stopSelector);
    while (el) {
        if (el.matches(selector)) {
            retval = el;
            break
        } else if (stopSelector && el.matches(stopSelectorString)) {
            break
        }
        el = el.parentElement;
    }
    return retval;
}

export function getSelector(el: HTMLElement | string): string {
    if(typeof(el) === "string") {
        return el;
    }

    let retVal = "", curEl: HTMLElement | null = el;

    while(curEl) {
        let curClass = curEl.classList.item(0),
            curVal = el.tagName;
            
        if(retVal) {
            retVal = ">" + retVal;
        }

        if(curClass) {
            curVal += "." + curClass;
        }
        
        retVal = curVal + retVal;

        curEl = curEl.parentElement;
    }

    return retVal;
}

export function getHorizontalScrollingParents(el:HTMLElement | null): HTMLElement[] {
    let result = [];
    while (el) {
        let parent = el.parentElement;
        if (parent && hasHorizontalScrollbar(parent)) {
            result.push(parent);
        }
        el = parent;
    }

    return result;
}

export function getClosestHorizontalScrollingParent(el:HTMLElement | null): HTMLElement | null {
    //alert(!!el);
    while (el) {
        let parent = el.parentElement;
        if (parent && hasHorizontalScrollbar(parent)) {
            return parent;
        }
        el = parent;
    }

    return null;
}

export function getClosestVerticalScrollingParent(el:HTMLElement | null): HTMLElement | null {
    while (el) {
        let parent = el.parentElement;
        if (parent && hasVerticalScrollbar(parent)) {
            return parent;
        }
        el = parent;
    }

    return null;
}

export function hasHorizontalScrollbar(el: Element): boolean {
    let overflowX: string = window.getComputedStyle(el)["overflow-x"];
    return overflowX === "scroll" || (overflowX === "auto" && el.scrollWidth > el.clientWidth);
}

export function hasVerticalScrollbar(el: Element): boolean {
    let overflowY: string = window.getComputedStyle(el)["overflow-y"];
    return overflowY === "scroll" || (overflowY === "auto" && el.scrollHeight > el.clientHeight);
}

export function hasScrollBar(el: HTMLElement): boolean {
    return hasHorizontalScrollbar(el) || hasVerticalScrollbar(el);
}

/*
    Allows a format string to be populated with values. See http://jsfiddle.net/3zy1pLdu/2/ for working example.
    
    Different possible inputs: 
        1) An object can be passed to replace named format placeholders, 
            ex: stringFormat("This is a {desc} format", {desc: 'object'}) returns "This is a object format";
        2) An array can be passed to replace numeric format placeholders, 
            ex : stringFormat("This is a {0} format", ['array']) returns "This is a array format";
        3) Any nubmer of strings or numbers can be passed to replace numeric format placeholders, 
            ex : stringFormat("This is a {0}, {1} format", 'string', 12) returns "This is a string, 12 format";
*/
export function stringFormat(str: String, ...args: any[]): String {
    let result = str;
    
    args.forEach((arg, i) => {
        let t = typeof arg;
        if(t === "object") {//Handles arrays or objects
            for (let key in arg) {
                result = result.replace(new RegExp(`\\{${key}\\}`, "gi"), arg[key]);
            }
        } else {//handles base strings or numbers
            result = result.replace(new RegExp(`\\{${i}\\}`, "g"), arg)
        }
    });

    return result;
}

export function moneyFormat(num: number, alwaysShowDecimals: Boolean, negativeParenthesis: Boolean): String{
    let result = "";

    num = Number(num);
    if (!isNaN(num)) {

        negativeParenthesis = negativeParenthesis || false;

        var fixedNumber = 0;
        if (!alwaysShowDecimals) {
            if (num % 1 !== 0) {
                fixedNumber = 2;
            }
        }
        else {
            fixedNumber = 2;
        }

        result = '$' + num.toFixed(fixedNumber).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
        if (negativeParenthesis && num < 0) {
            var amount = num * -1;
            result = '($' + amount.toFixed(fixedNumber).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,") + ')';
        }
    }

    return result;
}

export function getCookie(cname: string) {
    var name = cname + "=";
    var decodedCookie = decodeURIComponent(document.cookie);
    var ca = decodedCookie.split(';');
    for(var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return "";
}

export function groupArrayBy(arr: any[], key: string | Function): any[] {
    let result:Array<any> = [];

    arr.forEach(x => {
        let itemKey = typeof(key) === "string" ? x[key] : key(x),
            group = result.find((y: any) => y.group === itemKey);

        if(!group) {
            group = { group: itemKey, items: [] };
            result.push(group);
        }
        group.items.push(x);
    });
    
    return result;
};

export function deepCloneArray(array: Array<any>) {
    var result = <Array<any>>[];

    array.forEach(orig => result.push(Object.assign(Object.create(Object.getPrototypeOf(orig)), orig)));

    return result;
}